/* Zorina Mast — akcije (metaobjekt zm_akcija): prikaz prema datumu + rotacija trake */
(function () {
  'use strict';
  function now() { return Date.now() / 1000; }
  function apply() {
    var t = now();
    document.querySelectorAll('[data-ak-s]').forEach(function (el) {
      var s = +el.getAttribute('data-ak-s'), e = +el.getAttribute('data-ak-e');
      var on = t >= s && t < e;
      var show = el.hasAttribute('data-ak-off') ? !on : on;
      if (el.hidden === show) el.hidden = !show;
    });
    document.querySelectorAll('[data-zm-rot]').forEach(function (box) {
      if (!box.querySelector('.zm-ann__msg.is-active:not([hidden])')) {
        box.querySelectorAll('.zm-ann__msg.is-active').forEach(function (x) { x.classList.remove('is-active'); });
        var f = box.querySelector('.zm-ann__msg:not([hidden])');
        if (f) f.classList.add('is-active');
      }
    });
    document.querySelectorAll('[data-ak-bar]').forEach(function (bar) {
      var m = bar.querySelector('[data-ak-msg]');
      var on = m && !m.hidden;
      bar.style.background = on ? (bar.getAttribute('data-ak-bg') || '') : '';
      bar.style.color = on ? (bar.getAttribute('data-ak-fg') || '') : '';
    });
  }
  function rotate() {
    document.querySelectorAll('[data-zm-rot]').forEach(function (box) {
      if (box._zmRot) return;
      box._zmRot = true;
      var speed = (parseInt(box.getAttribute('data-zm-rot'), 10) || 5) * 1000;
      setInterval(function () {
        var items = Array.prototype.filter.call(box.querySelectorAll('.zm-ann__msg'), function (x) { return !x.hidden; });
        if (items.length < 2) return;
        var i = items.findIndex(function (x) { return x.classList.contains('is-active'); });
        items.forEach(function (x) { x.classList.remove('is-active'); });
        items[(i + 1) % items.length].classList.add('is-active');
      }, speed);
    });
  }
  function run() { apply(); rotate(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  setInterval(apply, 15000);
  document.addEventListener('shopify:section:load', run);
})();